import './index.css'
import Button from '../button';
import StatusPill from '../status-pill';
import { useState } from 'react';

function PostIdea({date, generatedFrom, content, status, id, display, expandIdea, SetExpandedIdea, handleDeleteRequest, scheduledDate, ideaType, image, voiceName, approved, linkedinStatus, voiceId, postingToLinkedIn, posted, linkedinPostUrl, pending}){

    const confirmDeletion = () => {
        setDeleteState({text: "Sure?", action: () => handleDeleteRequest(id)});
    }

    const [deleteState, setDeleteState] = useState({text: "Delete", action: confirmDeletion});

    let displayToSet = display === 'none' ? 'flex' : 'none';

    const handleOpenIdea = async (id) => {
        let ideaStructure = {
            "id": id,
            "title": `${generatedFrom}`,
            "generatedFrom": generatedFrom,
            "stage": status,
            "structure": content,
            "scheduledDate": scheduledDate,
            "ideaType": "post",
            "image": image,
            "approved": approved,
            "voiceName": voiceName,
            "voiceId": voiceId,
            "linkedinStatus": linkedinStatus,
            "linkedinPostUrl": linkedinPostUrl,
            "pending": pending
        }
        await SetExpandedIdea(ideaStructure);
        expandIdea();
    }

    const formattedDate = scheduledDate
        ? new Date(scheduledDate).toLocaleString(undefined, {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        })
        : null;

    return (
        <div className='idea-item-border post-idea' style={{display: displayToSet}}>
            <div className='idea-item idea'>
                <div className='idea-info-holder'>
                    <div className='tiny-text date'>{new Date(date).toDateString()}</div>
                    <div className='post-idea-voice-badge'>
                        <img className='extra-info-image' src='./images/team.png' alt='' />
                        <span className='tiny-text'>{voiceName}</span>
                    </div>
                </div>

                <div className='post-title-holder'><h2>{generatedFrom}</h2></div>

                <div className='post-idea-statuses'>
                    <StatusPill colour='#0AFB60' text={approved ? 'Approved' : 'Not approved'} active={!!approved} />
                    <StatusPill colour='#0AFB60' text={linkedinStatus === 'connected' ? 'Connected' : 'Not connected'} active={linkedinStatus === 'connected'} />
                    <StatusPill colour='#0AFB60' text={posted ? 'Posted' : 'Not posted'} active={!!posted} />
                    <StatusPill colour='#0AFB60' text={postingToLinkedIn && linkedinStatus === 'connected' ? 'Scheduled to auto-post to LinkedIn' : 'Not auto-posting to LinkedIn'} active={!!postingToLinkedIn && linkedinStatus === 'connected'} />
                </div>

                {formattedDate && (
                    <StatusPill colour='#0AFB60' text={formattedDate} active={true} />
                )}

                <div className='idea-action-bar'>
                    <Button text='View post' smallBool={true} addedFunction={handleOpenIdea} params={id} />
                    <Button text={deleteState.text} smallBool={true} addedFunction={deleteState.action} params={id} />
                </div>

                {posted && linkedinPostUrl && (
                    <a href={linkedinPostUrl} target="_blank" rel="noreferrer" className="view-on-linkedin-card-link">
                        <Button image='./images/linkedin.png' text='View on LinkedIn' smallBool={true} />
                    </a>
                )}
            </div>
        </div>
    );
}

export default PostIdea
